// src/components/ui/Card.js
import React from 'react';

const GlassCard = ({ children, className = '', onClick = () => {} }) => (
    <div
        className={`bg-white dark:bg-white/10 backdrop-filter backdrop-blur-lg border border-gray-200 dark:border-white/20 rounded-xl shadow-lg p-4 sm:p-6 transition-all duration-300 ease-in-out ${className}`}
        onClick={onClick}
    >
        {children}
    </div>
);

export default GlassCard;